import {FC, useMemo} from 'external/react'

import { Offer } from '../../../types/offer'

export type OfferHeaderProps = {
    offer: Offer
}

const OfferHeader: FC<OfferHeaderProps> = (props) => {
	
	const { offer } = props
	const {name, plan, price} = offer

	return (
		<>
			<p style={{ margin: '0' }}>
				{price}{' '}
				<span className='span_plan text-capitalize'>/{plan}</span>
			</p>
			<div className='programLevel text-capitalize'>{name}</div>
		</>
	)
}

export {OfferHeader as default}